import axios from "axios";
// import crypto from "crypto";

import FormData from "form-data";

import { useEffect, useState } from "react";
import sha256 from "sha256";

// Making the POST request

const Airpay = () => {
  const main =async (data,date) => {
    const secret = "5d3VVJ3W4AC99ayR";
    const username = "JfXAvB2kXZ";
    const password = "v5x8vA4K";

    const key = sha256(username + "~:~" + password);

    function generatePrivateKey(secret, username, password) {
      const secretUsernamePassword = `${secret}@${username}:|:${password}`;
      const privateKey = sha256(secretUsernamePassword);
      return privateKey;
    }

    const privateKeys = generatePrivateKey(secret, username, password);

    // const data = {
    //   buyerEmail: "test@test.com",
    //   buyerPhone: "1234567890",
    //   buyerFirstName: "test",
    //   buyerLastName: "test",
    //   buyerAddress: "",
    //   buyerCity: "",
    //   buyerState: "",
    //   buyerCountry: "",
    //   buyerPinCode: "",
    //   orderid: "test123409",
    //   amount: "1.0",
    //   privatekey:
    //     "5ace130b8751cf6bc133e9c07c6a9f34184e5aae91b6c3ef3a2f679e0259e2e4",
    //   mercid: 293856,
    //   chmod: "",
    //   checksum:
    //     "4248a491879017b2364febd6336ec9866319dbf18494866b6539c08a184e6d64",
    //   currency: 356,
    //   isocurrency: "INR",
    //   txnsubtype: "",
    // };
    function generateAllData2(data) {
      // console.log(data);
      const keysToInclude = [
        "buyerEmail",
        "buyerFirstName",
        "buyerLastName",
        "buyerAddress",
        "buyerCity",
        "buyerState",
        "buyerCountry",
        "amount",
        "orderid",
        "UID",
        "siindexvar",
        "date",
      ];

      let result = [];
      keysToInclude.forEach((element) => {
        if (data[element]) {
          if (element === "amount" && typeof data[element] === "number") {
            result.push(data[element].toFixed(2)); // Keep 2 decimal places
          } else {
            result.push(data[element]);
          }
        }
      });
      result.push(date);
      console.log({ result });

      return result.join("");
    }

    const alldata = generateAllData2(data);

    const checksum = sha256(`${key}@${alldata}`);
    const text = sha256(`${key}@${alldata}`);
    console.log({ alldata, text });
    console.log({
      unhashed: `${key}@${alldata}`,
      privateKeys,
      checksum,
    });
    // console.log(type == alldata, "-------------");
    data.checksum = checksum;
    data.privatekey = privateKeys;
    return data;
  };

  const makePostRequest = async (data) => {
    const url = "https://payments.airpay.co.in/pay/index.php";

    // Create a new FormData instance
    const formData = new FormData();

    // Append each key-value pair from the data object to the form data
    for (const key in data) {
      formData.append(key, data[key]);
    }
// console.log({data})
    // Set the headers with the form data included
    const headers = {
      "Content-Type": "multipart/form-data", // Remove the extra comma
    };

    const response = await axios.post(url, formData, { headers });

    return response.data;
  };
  const defaultVal= {
    buyerEmail: "test@test.com",
    buyerPhone: "1234567890",
    buyerFirstName: "test",
    buyerLastName: "test",
    buyerAddress: "",
    buyerCity: "",
    buyerState: "",
    buyerCountry: "",
    buyerPinCode: "",
    orderid: "test123409",
    amount: "1.0",
    privatekey:
      "5ace130b8751cf6bc133e9c07c6a9f34184e5aae91b6c3ef3a2f679e0259e2e4",
    mercid: 293856,
    chmod: "",
    checksum:
      "4248a491879017b2364febd6336ec9866319dbf18494866b6539c08a184e6d64",
    currency: 356,
    isocurrency: "INR",
    txnsubtype: "",
  }
  const [data, setData] = useState(defaultVal);
  const [currDate,setCurrdate]= useState("2023-10-16")
  const [formData, setFormData] = useState(data);
  const [submitted, setSubmitted] = useState(false);
  const [iframeSrc, setIframeSrc] = useState(null);
  // const [data, setData] = useState("");
  console.log("trigerred",data)
  // useEffect(() => {
   
  //   if (submitted) {
  //     // When 'submitted' state is true, set the iframe source URL
      
  //   }
  // }, [submitted, data]);
  const handleClick = async () => {
    try {
      // Get the data you want to send in the POST request from the `main` function.
      const mas = await main(); // Assuming `main` function is defined elsewhere.

      // Make the POST request.
      const response = await makePostRequest(mas);

      // console.log('Response:', response);
      setSubmitted(true);

      // Update the state with the received HTML.
      setData(response.data);
      setIframeSrc("data:text/html," + encodeURIComponent(response.data));
    } catch (error) {
      // console.error('Error:', error);
    }
  };
const handleSubmit=async(e)=>{
  e.preventDefault()
  const mas = await main(formData,currDate); // Assuming `main` function is defined elsewhere.
  // Make the POST request.
  const response = await makePostRequest(mas);
  console.log(response)
}
const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
};
    return (
      <div>
        <form onSubmit={handleSubmit}>
          <label>
            Email:
            <input
              type="text"
              name="buyerEmail"
              value={formData.buyerEmail}
              onChange={handleChange}
            />
          </label>
          <label>
          buyerPhone:
            <input
              type="text"
              name="number"
              value={formData.buyerPhone}
              onChange={handleChange}
            />
          </label>
          <label>
          buyerFirstName:
            <input
              type="text"
              name="buyerFirstName"
              value={formData.buyerFirstName}
              onChange={handleChange}
            />
          </label>
          <label>
          buyerLatName:
            <input
              type="text"
              name="buyerLastName"
              value={formData.buyerLastName}
              onChange={handleChange}
            />
          </label>
          <label>
          order_id:
            <input
              type="text"
              name="orderid"
              value={formData.orderid}
              onChange={handleChange}
            />
          </label>
          <label>
          date:
            <input
              type="text"
              name="date"
              value={currDate}
              onChange={(e)=>setCurrdate(e.target.value)}
            />
          </label>
          {/* Add similar input fields for other form values */}
          <button type="submit">Submit</button>
        </form>
      </div>
    );
  
};





export default Airpay;
